import { useState } from 'react';
import { FaCopy } from 'react-icons/fa';
import NewTooltip from '../../../atoms/NewTooltip';

interface LabelCopyProps {
  text: string;
  tooltip?: string;
  className?: string;
}

export default function LabelCopy({ text, tooltip = 'Copiar', className = 'text-sm text-gray-900 dark:text-gray-100' }: LabelCopyProps) {
  const [isHovered, setIsHovered] = useState(false);

  const copyToClipboard = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(text);
  };

  return (
    <div
      className="inline-flex items-center gap-2"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span className={className}>{text}</span>
      {isHovered && (
        <NewTooltip content={tooltip} alignment="top">
          <button onClick={copyToClipboard} className="text-blue-500 hover:text-blue-700">
            <FaCopy size={12} />
          </button>
        </NewTooltip>
      )}
    </div>
  );
}
